import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ProblemSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const problems = [
    {
      before: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      after: "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      title: "Verschmutzter Lack",
      description: "Ihr Auto verliert täglich an Wert durch Schmutz, Kratzer und UV-Schäden"
    },
    {
      before: "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      after: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      title: "Innenraum-Verschleiß",
      description: "Flecken, Gerüche und Abnutzung mindern Komfort und Wiederverkaufswert"
    },
    {
      before: "https://images.unsplash.com/photo-1609521263047-f8f205293f24?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      after: "https://images.unsplash.com/photo-1544636331-e26879cd4d9b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      title: "Lackschäden",
      description: "Kleine Kratzer und Steinschläge werden zu kostspieligen Reparaturen"
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % problems?.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + problems?.length) % problems?.length);
  };

  return (
    <section className="py-20 bg-gradient-to-b from-muted/30 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-primary/10 text-primary px-4 py-2 rounded-full mb-6">
            <Icon name="AlertTriangle" size={16} />
            <span className="text-sm font-medium">Häufige Probleme</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-6">
            Ihr Auto leidet unter
            <span className="block text-primary">täglichen Belastungen</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Ohne professionelle Pflege verliert Ihr Fahrzeug nicht nur an Schönheit, 
            sondern auch erheblich an Wert. Lassen Sie das nicht zu.
          </p>
        </div>

        {/* Before/After Slider */}
        {/* <div className="relative max-w-4xl mx-auto mb-16">
          <div className="relative h-96 md:h-[500px] rounded-2xl overflow-hidden shadow-card"> */}
            {/* Before Image */}
            {/* <div className="absolute inset-0">
              <Image
                src={problems?.[currentSlide]?.before}
                alt={`Vorher - ${problems?.[currentSlide]?.title}`}
                className="w-full h-full object-cover"
              />
              <div className="absolute top-4 left-4 bg-destructive text-white px-3 py-1 rounded-full text-sm font-medium">
                Vorher
              </div>
            </div> */}

            {/* After Image Overlay */}
            {/* <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-white/90">
              <div className="absolute right-0 top-0 w-1/2 h-full">
                <Image
                  src={problems?.[currentSlide]?.after}
                  alt={`Nachher - ${problems?.[currentSlide]?.title}`}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-4 right-4 bg-success text-white px-3 py-1 rounded-full text-sm font-medium">
                  Nachher
                </div>
              </div>
            </div> */}

            {/* Navigation Arrows */}
            {/* <button
              onClick={prevSlide}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/90 hover:bg-white rounded-full flex items-center justify-center shadow-lg transition-all"
              aria-label="Vorheriges Bild"
            >
              <Icon name="ChevronLeft" size={20} />
            </button>
            <button
              onClick={nextSlide}
              className="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/90 hover:bg-white rounded-full flex items-center justify-center shadow-lg transition-all"
              aria-label="Nächstes Bild"
            >
              <Icon name="ChevronRight" size={20} />
            </button> */}

            {/* Problem Info */}
            {/* <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
              <h3 className="text-2xl font-bold text-white mb-2">
                {problems?.[currentSlide]?.title}
              </h3>
              <p className="text-white/90">
                {problems?.[currentSlide]?.description}
              </p>
            </div>
          </div> */}

          {/* Slide Indicators */}
          {/* <div className="flex justify-center space-x-2 mt-6">
            {problems?.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-all ${
                  index === currentSlide ? 'bg-accent' : 'bg-muted-foreground/30'
                }`}
                aria-label={`Slide ${index + 1}`}
              />
            ))}
          </div>
        </div> */}

        {/* Pain Points */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="text-center p-6 bg-white rounded-xl shadow-card">
            <div className="w-16 h-16 bg-destructive/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="TrendingDown" size={24} className="text-destructive" />
            </div>
            <h3 className="text-lg font-bold text-foreground mb-3">Wertverlust</h3>
            <p className="text-sm text-muted-foreground">
              Ungepflegte Fahrzeuge verlieren bis zu 30% mehr Wert beim Wiederverkauf
            </p>
          </div>

          <div className="text-center p-6 bg-white rounded-xl shadow-card">
            <div className="w-16 h-16 bg-warning/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Clock" size={24} className="text-warning" />
            </div>
            <h3 className="text-lg font-bold text-foreground mb-3">Zeitverlust</h3>
            <p className="text-sm text-muted-foreground">
              Selbst waschen kostet Zeit und liefert selten professionelle Ergebnisse
            </p>
          </div>

          <div className="text-center p-6 bg-white rounded-xl shadow-card">
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="Frown" size={24} className="text-primary" />
          </div>
            <h3 className="text-lg font-bold text-foreground mb-3">Frustration</h3>
            <p className="text-sm text-muted-foreground">
              Schlechte Ergebnisse bei Autowaschanlagen führen zu Enttäuschung
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            className="group relative inline-flex items-center justify-center text-sm rounded-xl bg-primary px-6 py-2 font-semibold text-white transition-all duration-200 hover:bg-primary/90 hover:shadow-lg hover:-translate-y-0.5 hover:shadow-primary/30"
            onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Lösung entdecken
            <svg
              aria-hidden="true"
              viewBox="0 0 10 10"
              height="10"
              width="10"
              fill="none"
              className="mt-0.5 ml-2 -mr-1 stroke-white stroke-2"
            >
              <path
                d="M0 5h7"
                className="transition opacity-0 group-hover:opacity-100"
              ></path>
              <path
                d="M1 1l4 4-4 4"
                className="transition group-hover:translate-x-[3px]"
              ></path>
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;